// project import
import Routes from './routes';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { store } from 'store';
import { getJwt } from 'utils/localStorage';
import { verificarSessaoRequest } from 'reducers/autenticacao.reducer';

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

store.dispatch({ type: 'START_ATUALIZACAO_AUTOMATICA' });
store.dispatch({ type: 'START_PALETA_CORES' });

if (getJwt()) {
  store.dispatch(verificarSessaoRequest());
}

const App = () => (
  <ThemeCustomization>
    <ScrollTop>
      <Routes />
      <ToastContainer position="bottom-left" />
    </ScrollTop>
  </ThemeCustomization>
);

export default App;
